import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Module } from 'core/models/course-content.model';

@Component({
  selector: 'app-action-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './action-bar.html',
})
export class ActionBar {
  @Input() currentModule: Module | null = null;
  @Input() isPreviewMode = false;
  @Input() isCurrentModuleEmpty = false;

  @Output() togglePreview = new EventEmitter<void>();
  @Output() editModule = new EventEmitter<string>();
  @Output() deleteModule = new EventEmitter<string>();
  @Output() addLesson = new EventEmitter<string>();
  @Output() addQuestion = new EventEmitter<string>();

  protected onTogglePreview(): void {
    this.togglePreview.emit();
  }

  protected onEditModule(moduleId: string): void {
    this.editModule.emit(moduleId);
  }

  protected onDeleteModule(moduleId: string): void {
    this.deleteModule.emit(moduleId);
  }

  protected onAddLesson(moduleId: string): void {
    this.addLesson.emit(moduleId);
  }

  protected onAddQuestion(moduleId: string): void {
    this.addQuestion.emit(moduleId);
  }
}
